/**
 * Created by fruysshaert on 05/04/2017.
 */
import { JsonProduct } from '../../../baseBtl/catalog/products/interface/context';
import { EdpBase } from '../../../baseBtl/catalog/products/subscription/edp';

export class Edp extends EdpBase {
    public static readonly defaultData: JsonProduct = {
        type_id: 'edp',
        gencode: 'EPD0000000',
        sku: 'EPD0000000',
        price: 9999,
        products_ids: null,
        name: 'Etalement de paiement',
        media: null,
        plan_bonus: null,
    };
}
